import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialImports } from '../../material.imports';
import { AuthService } from '../../auth/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { ChooseLanguage } from '../choose-language/choose-language';
import { Notification } from "../notification/notification";

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [...MaterialImports, RouterModule, TranslateModule, ChooseLanguage, Notification],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {
  @Input() title: string = '';
  @Input() backLink: string = '/';
  @Input() showBackButton: boolean = true;
  @Input() showLogout: boolean = true;

  constructor(private authService: AuthService) {}

  logout() {
    this.authService.logout();
  }
}